import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export type SetSearchParamFunction = (paramName: string, paramValue: string | undefined, replace?: boolean) => void;

export function useSearchParamsEx(): [URLSearchParams, SetSearchParamFunction] {
	const [searchParams, setSearchParams] = useSearchParams();

	const setSearchParam: SetSearchParamFunction = useCallback(
		(paramName: string, paramValue: string | undefined, replace: boolean = true) => {
			setSearchParams(
				(searchParams) => {
					const nextSearchParams = new URLSearchParams(searchParams);
					if (paramValue === undefined) {
						nextSearchParams.delete(paramName);
					} else {
						nextSearchParams.set(paramName, paramValue);
					}
					return nextSearchParams;
				},
				{ replace },
			);
		},
		[setSearchParams],
	);

	return [searchParams, setSearchParam];
}
